// Serviço de notificações in-app.
import { createClient } from '@/lib/supabase/client'
import type { Notificacao } from '@/lib/types'

export async function listNotificacoes(limit = 50): Promise<Notificacao[]> {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('notificacoes')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) throw error
  return (data ?? []) as Notificacao[]
}

export async function contarNaoLidas(): Promise<number> {
  const supabase = createClient()
  const { count, error } = await supabase
    .from('notificacoes')
    .select('id', { count: 'exact', head: true })
    .is('lida_em', null)
  if (error) return 0
  return count ?? 0
}

export async function marcarLida(id: string) {
  const supabase = createClient()
  await supabase.from('notificacoes').update({ lida_em: new Date().toISOString() }).eq('id', id)
}

export async function marcarTodasLidas() {
  const supabase = createClient()
  await supabase.from('notificacoes').update({ lida_em: new Date().toISOString() }).is('lida_em', null)
}

/** Envia notificação in-app para um colega do workspace. Nunca bloqueia o fluxo. */
export async function notificar(params: {
  workspaceId: string
  userId: string
  tipo: string
  titulo: string
  corpo?: string | null
  link?: string | null
}) {
  try {
    const supabase = createClient()
    await supabase.from('notificacoes').insert({
      workspace_id: params.workspaceId,
      user_id: params.userId,
      tipo: params.tipo,
      titulo: params.titulo,
      corpo: params.corpo ?? null,
      link: params.link ?? null,
    })
  } catch {
    // silencioso por design
  }
}
